import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireMinRole } from "@/lib/route-guards";

export const Route = createFileRoute("/dashboard/_admin/company")({
  component: () => <Outlet />,
  beforeLoad: ({ context }) => {
    // Company management is platform-admin only; non-admins get the explicit
    // "not authorised" page rather than a silent bounce (CTE-127).
    requireMinRole(context.session, "admin", "/no-access");
  },
});
